const STIHealthInsurance = () => {
    return (
        <div>

            <div className="flex flex-col justify-center items-center">
            <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
            <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                
                    <div className="flex flex-col justify-center lg:max-w-[25rem] md:w-[30rem]">
                        <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                            Sahulat Telehealth Insurance
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                         TPL Life Sahulat is a telehealth platform provides customers an easy access to appointments 
                         with the consultants and physicians, along with the benefit of ordering lab tests and 
                         medicines, all from the comfort of their homes.
                        </p>
                      
                            
                    </div>
                    <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/financial-services/sahulat.jpg" alt="" className="max-w-[100%] rounded-md"/>
                    </div>
                </div>

            </div>
        </div>
    )
};

export default STIHealthInsurance;